export default __webpack_public_path__ + "circle-with-an-arrow-pointing-to-left.png";